export default {"src":"/_next/static/media/ads-layout.569baaef.svg","height":296,"width":362,"blurWidth":0,"blurHeight":0};